import * as types from '../types/suggestionTypes';
import * as suggestionService from '../../services/suggestionService';
import { addSuggestion } from '../../utils/activityStore';

export const submitSimilarSuggestion =
  (category, baseId, payload) => async (dispatch) => {
    dispatch({ type: types.SUBMIT_SUGGESTION_REQUEST });
    try {
      if (payload?.baseTitle && payload?.suggestedTitle) {
        addSuggestion({
          baseTitle: payload.baseTitle,
          suggestedTitle: payload.suggestedTitle,
          reason: payload.reason || '',
          status: 'pending',
        });
      }
      const data = await suggestionService.submitSimilarSuggestion(category, baseId, payload);
      dispatch({
        type: types.SUBMIT_SUGGESTION_SUCCESS,
        payload: data.message || 'Suggestion sent.',
      });
    } catch {
      if (payload?.baseTitle && payload?.suggestedTitle) {
        addSuggestion({
          baseTitle: payload.baseTitle,
          suggestedTitle: payload.suggestedTitle,
          reason: payload.reason || '',
          status: 'pending',
        });
      }
      dispatch({
        type: types.SUBMIT_SUGGESTION_SUCCESS,
        payload: 'Thanks! (Demo — your suggestion would be sent when the API is connected.)',
      });
    }
  };

export const resetSuggestion = () => ({ type: types.SUGGESTION_RESET });
